export default __webpack_public_path__ + "static/media/spr_logo.f4211a78.png";